import { UserDashboard } from "./userDashboard";
import { Notifications } from "../../../../ui/blocks/notifications/notifications";

export function UserNotifications() {

  return (
    <UserDashboard>
      <Notifications/>
    </UserDashboard>
  );
}
